export const priceTransform = (value) => {
  const clean = String(value ?? '').replace(/\D/g, '');
  return String(+clean).padStart(3, '0').replace(/(..)$/, '.$1');
};

export const formatPrice = (value) => {
  return Number(value).toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: 0,
  });
};

export const formatNumber = (value) => {
  // Ensure that the value is displayed with trailing zeros only when necessary
  const floatValue = parseFloat(value);
  return floatValue.toFixed(2);
};
